import { z } from 'zod';

/**
 * Fulfillment details schema for nested fulfillment information
 * Used for tracking, contact, and company information
 */
const fulfillmentDetailsSchema = z.object({
    /** Optional vehicle tracking reference */
    vehicleTrackingReference: z.string().optional(),
    /** Optional contact number */
    contactNumber: z.string().optional(),
    /** Optional company name */
    companyName: z.string().optional(),
});
/**
 * Mark in transit to buyer form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(markInTransitToBuyerFormSchema)
 */
const markInTransitToBuyerFormSchema = z.object({
    /** Estimated delivery date (top-level field in ms since epoch) */
    estimatedDeliveryDate: z.number().int().positive().optional(),
    /** Fulfillment details (nested object) */
    fulfillmentDetails: fulfillmentDetailsSchema.optional(),
});
/**
 * Mark delivery fulfilled form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(markDeliveryFulfilledFormSchema)
 */
const markDeliveryFulfilledFormSchema = z.object({
    isConfirmed: z.boolean().refine((val) => val === true, {
        message: 'Please confirm delivery has been fulfilled',
    }),
});
/**
 * Mark pickup scheduled form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(markPickupScheduledFormSchema)
 */
const markPickupScheduledFormSchema = z.object({
    isConfirmed: z.boolean().refine((val) => val === true, {
        message: 'Please confirm pickup has been scheduled',
    }),
});
/**
 * Mark pickup fulfilled form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(markPickupFulfilledFormSchema)
 */
const markPickupFulfilledFormSchema = z.object({
    isConfirmed: z.boolean().refine((val) => val === true, {
        message: 'Please confirm pickup has been fulfilled',
    }),
});
/**
 * Mark received at fulfillment center form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(markReceivedAtFulfillmentCenterFormSchema)
 */
const markReceivedAtFulfillmentCenterFormSchema = z.object({
    isConfirmed: z.boolean().refine((val) => val === true, {
        message: 'Please confirm vehicle has been received at fulfillment center',
    }),
});
/**
 * Mark delivery scheduled form schema for react-hook-form with zodResolver
 * Use with: resolver: zodResolver(markDeliveryScheduledFormSchema)
 */
const markDeliveryScheduledFormSchema = z.object({
    isConfirmed: z.boolean().refine((val) => val === true, {
        message: 'Please confirm delivery has been scheduled',
    }),
    // TODO: Add date/time fields if present in actual component
});

export { fulfillmentDetailsSchema, markDeliveryFulfilledFormSchema, markDeliveryScheduledFormSchema, markInTransitToBuyerFormSchema, markPickupFulfilledFormSchema, markPickupScheduledFormSchema, markReceivedAtFulfillmentCenterFormSchema };
//# sourceMappingURL=fulfillmentValidation.js.map
